import NextImage from "next/image";
import { IconCheck } from "@tabler/icons";
import s from "../styles/MediaStage.module.css";

/*
  במה לתמונות המוצר בדף הבית — לפי הקו העיצובי (goappie + michal-yogev):
  המכשיר "פורץ" מבלוק בצבע המותג, כתם אורגני נשפך מהקצה, כדורי פיצ'רים
  מרחפים, ומוטיב החץ ↖. כל וריאנט מקבל קומפוזיציה אחרת כדי שהדף לא יחזור על עצמו.

  variant:
    phone  — טלפון שעולה מתוך בלוק, נחתך בתחתית הבלוק
    screen — צילום מסך רוחבי שחורג מבלוק שמוסט לצד
    photo  — צילום אווירה מוטה, עם בלוק מותג מוטה הפוך מאחוריו (ערימת כרטיסים)
    dark   — רנדר כהה על פאנל לילה עם זוהר מותג
*/
export function MediaStage({
  image,
  alt,
  variant = "phone",
  tone = "brand",
  callouts = [],
  arrow = false,
  sizes = "(max-width: 800px) 80vw, 420px",
  className = "",
}) {
  return (
    <figure
      className={[s.stage, s[variant], s[`tone_${tone}`], className].join(" ")}
    >
      <span className={s.blob} aria-hidden="true" />
      {arrow && <span className={s.arrow} aria-hidden="true" />}

      <div className={s.device}>
        <span className={s.block} aria-hidden="true" />
        <NextImage
          src={image}
          alt={alt}
          sizes={sizes}
          quality={85}
          className={s.img}
        />
      </div>

      {callouts.length > 0 && (
        <ul className={s.callouts} aria-hidden="true">
          {callouts.map((text, i) => (
            <li key={text} className={`${s.callout} ${s[`c${i}`]}`}>
              <span className={s.calloutIcon}>
                <IconCheck size={13} stroke={3} />
              </span>
              {text}
            </li>
          ))}
        </ul>
      )}
    </figure>
  );
}

export default MediaStage;
